import React, { useEffect } from "react";
import { Form, Button, Tooltip } from "antd";
import { useController } from "react-hook-form";
import { UploadOutlined, CloseOutlined } from "@ant-design/icons";
import { getError } from "../../../utils/form";

const itemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    lg: { span: 10 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    lg: { span: 14 },
  },
};

const ControlledFileInput = ({
  control,
  errors,
  name,
  label,
  additionalText = null,
  required,
  acceptedFileType = [],
  valueForInputField = "",
}) => {
  const error = getError({ errors, name });
  const fileRef = React.useRef(null);
  const { field } = useController({ control, name });
  const [value, setValue] = React.useState("");
  const [fileName, setFileName] = React.useState("");
  const [fileInputError, setFileInputError] = React.useState(null);
  const [fileSizeError, setFileSizeError] = React.useState(false);

  useEffect(() => {
    if (valueForInputField.length) setFileName(valueForInputField);
  }, [valueForInputField]);

  const acceptedFileExtension = [];
  let acceptedValuesString = "";

  if (acceptedFileType.length) {
    acceptedFileType.forEach((fileType) => {
      if (
        fileType === "zip" ||
        fileType === "application/zip" ||
        fileType === "application/x-zip" ||
        fileType === "application/x-zip-compressed"
      ) {
        if (acceptedFileExtension.indexOf(".zip") === -1)
          acceptedFileExtension.push(".zip");
      } else if (
        fileType === "csv" ||
        fileType === "application/csv" ||
        fileType === "text/csv"
      ) {
        if (acceptedFileExtension.indexOf(".csv") === -1)
          acceptedFileExtension.push(".csv");
      } else if (fileType === "jpeg" || fileType === "image/jpeg") {
        if (acceptedFileExtension.indexOf(".jpeg") === -1)
          acceptedFileExtension.push(".jpeg");
      } else if (fileType === "jpg" || fileType === "image/jpg") {
        if (acceptedFileExtension.indexOf(".jpg") === -1)
          acceptedFileExtension.push(".jpg");
      } else {
        acceptedFileExtension.push(`.${fileType.split("/")[1]}`);
      }
    });

    acceptedValuesString = acceptedFileExtension.join(", ");
  }

  //console.log("errors file-", error);
  const handleFileClick = (e) => {
    e.preventDefault();
    fileRef.current.click();
  };

  const handleOnChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 100 * 1024 * 1024) {
      setFileSizeError(true);
      return;
    }
    setValue(e.target.value);
    setFileName(e?.target?.files[0]?.name);
    field.onChange(e.target.files[0]);
    setFileInputError(null);
    setFileSizeError(false);
  };
  
  return (
    <Form.Item
      label={label}
      {...itemLayout}
      required={required}
      labelAlign="left"
      validateStatus={error ? "error" : "success"}
      help={error?.message}
    >
      <input
        value={value}
        style={{ display: "none" }}
        
        onChange={(e) => {
          /*   if (e.target.files[0]?.type === "application/pdf") {
          if (e.target.files[0]?.size > 12 * 1024 * 1024) {
            console.log("reached file size error");
            setFileSizeError(true);
          } */

          if (
            acceptedFileType.length &&
            acceptedFileType.indexOf(e.target.files[0]?.type) === -1
          ) {
            setFileInputError(true);
          } else {
            handleOnChange(e);
          }
          /*}   else if (e.target.files[0]?.type !== "application/pdf") {
            setFileInputError(true);
          }  else {
            setFileInputError(null);
            setFileSizeError(false);
          }*/
        }}
        type="file"
        accept=""
        ref={fileRef}
      />
      {additionalText && (
        <em>
          <strong>{additionalText}</strong>
        </em>
      )}
      {/* <em style={{marginTop:"-10px"}}>Upload Digital Signed PDF only</em> */}
      {fileName ? (
        <div
          style={{
            display: "flex",
            width: "100%",
            border: "1px dashed #d9d9d9",
            background: "#fff",
            height: 32,
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 10px",
            color: "rgba(0, 0, 0, 0.85)",
          }}
        >
          <Tooltip title={fileName}>
            <span
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "calc(100% - 50px)",
              }}
            >
              {fileName}
            </span>
          </Tooltip>
          <Button
            type="link"
            size="small"
            icon={<CloseOutlined />}
            onClick={() => {
              setValue("");
              setFileName(null);
              field.onChange("");
            }}
          />
        </div>
      ) : (
        <Button
          block
          type="dashed"
          icon={<UploadOutlined />}
          onClick={handleFileClick}
        >
          Click to upload
        </Button>
      )}
      {fileInputError && (
        <p
          style={{
            color: "#ff4d4f",
            fontSize: "14px",
          }}
        >
          {`Please upload ${acceptedValuesString} files only`}
        </p>
      )}
      {fileSizeError && (
        <p
          style={{
            color: "#ff4d4f",
            fontSize: "14px",
          }}
        >
          Size of the file exceeds 100 MB. Please try to upload file size less
          than 100 MB
        </p>
      )}
    </Form.Item>
  );
};

export default ControlledFileInput;
